// extracted by mini-css-extract-plugin
export default {"JobNotification":"styles_JobNotification__zdMdz","notifications":"styles_notifications__w7eE4"};